// Old page addresses that the live (Drupal) site redirects to a page's current address.
// Page bodies and outside links still use them, so they are sent on the same way here.
// Keys and values are paths without the leading slash.
export const PAGE_REDIRECTS = {
  'athlete-representation-certificate': 'sports-agent-advanced-certificate',
  'collegecredit.asp': 'courses/earn-college-credit',
  'conferences/MLS-NSCAA-sports-career-conference': 'conferences/MLS-sports-career-conference',
  'conferences/mls-preseason-meet-and-greet': 'conferences/mls-preseason-soccer-career-conference',
  'conferences/vegas-summer-league-sports-career-conference': 'LasVegas-Basketball-Career-Conference',
  'content/hockey-analytics': 'courses/hockey-analytics',
  'content/sports-agent-course-faq': 'courses/sports-agent/faq',
  'content/sports-management-degrees': 'content/sports-leadership-degrees',
  'course/salary-cap-analysis': 'courses/salary-cap-analysis',
  'courses/athlete-management-sports-agent/salaries': 'program/salaries',
  'courses/digital-video-editing': 'courses/football-video-performance-analysis-catapult',
  'courses/digital-video-editing-hockey': 'courses/hockey-video-performance-analysis-catapult',
  'courses/digital-video-editing-synergy': 'courses/basketball-video-performance-analysis-synergy',
  'courses/proficiency-in-pff-ultimate': 'courses/proficiency-in-pff-premium',
  'courses/soccer-management': 'courses/soccer-scouting',
  'courses/soccer-talent-identification': 'courses/soccer-player-development',
  'courses/sports-betting': 'courses/sports-cryptocurrency',
  'courses/sports-marketing-communications': 'courses/sports-media-content-strategy',
  'courses/sports-product-marketing': 'courses/athletic-design-manufacturing',
  'courses/sports-revenue-management': 'courses',
  'directors': 'staff',
  'military-discount': 'gi-bill-sports-management',
  'mixed-martial-arts-course': 'courses/mixed-martial-arts-course',
  'nbasummerleaguesportscareerconference.asp': 'LasVegas-Basketball-Career-Conference',
  'sports-management-degrees': 'sports-management-masters-degree',
  'sportsjobstraining.asp': 'courses',
  'talk-with-dr-lashbrook': 'talk-with-dr-lynn-lashbrook',
  // The other way round: the live site's address of a page this site still keeps under its
  // older one (the video analysis course FAQs)
  'courses/basketball-video-performance-analysis-synergy/faq': 'courses/digital-video-editing-synergy/faq',
  'courses/hockey-video-performance-analysis-catapult/faq': 'courses/digital-video-editing-hockey/faq',
};
